import { useEffect } from "react";
import api from "../api";
import Cookies from "js-cookie";

declare global {
  interface Window {
    __PUSH_SUBSCRIBED__?: boolean;
  }
}

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function usePushSubscription() {
  useEffect(() => {
    // Keep hook for backwards compatibility if needed,
    // but do not auto-register on app load anymore.
    // Notification opt-in will be triggered explicitly from the Profile page.
  }, []);
}

export async function registerPushSubscription() {
  // Only attempt push registration for authenticated users
  const token = Cookies.get("_auth");
  if (!token) {
    return;
  }

  // Only run when app is in standalone (PWA) mode
  if (!window.matchMedia("(display-mode: standalone)").matches) {
    return;
  }

  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return;
  }

  if (!VAPID_PUBLIC_KEY) {
    return;
  }


  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return;
    }

    const registration = await navigator.serviceWorker.register("/sw.js");
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription && window.__PUSH_SUBSCRIBED__) {
      return;
    }

    const subscription =
      existingSubscription ||
      (await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      }));

    await api.post("/push/subscribe", { subscription });

    window.__PUSH_SUBSCRIBED__ = true;
  } catch (e) {
  }
}

export async function unsubscribePushSubscription() {
  const token = Cookies.get("_auth");
  if (!token) {
    return;
  }

  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    const existingSubscription = await registration.pushManager.getSubscription();
    if (!existingSubscription) {
      return;
    }

    const endpoint = existingSubscription.endpoint;
    await api.post("/push/unsubscribe", { endpoint });
    await existingSubscription.unsubscribe();

    window.__PUSH_SUBSCRIBED__ = false;
  } catch (e) {
    console.error("Error unsubscribing from push", e);
  }
}

